module.exports = __webpack_public_path__ + "img/9788961770644.c3a8c99e.jpg";